import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RegistrationState {
    registrationData: {
        email?: string;
        password?: string;
        code?: number;
        allowMarketing?: boolean;
        nearestRepresentative?: number;
    };
}

const initialState: RegistrationState = {
    registrationData: {},
};

const registrationSlice = createSlice({
    name: 'registration',
    initialState,
    reducers: {
        setRegistrationData: (state, action: PayloadAction<RegistrationState['registrationData']>) => {
            state.registrationData = action.payload;
        },
        clearRegistrationData: (state) => {
            state.registrationData = {};
        },
    },
});

export const { setRegistrationData, clearRegistrationData } = registrationSlice.actions;

export const registrationReducer = registrationSlice.reducer;
